export const planManagement = {
  backToSettingsCtaText: "Back to Settings",
  currentMembership: {
    details: "{{plan}} | ${{price}} {{interval}}",
    heading: "Current Membership Plan",
    nextBilling: "Next billing date: {{currentPeriodEnd}}",
  },
  form: {
    description:
      "Changes will take effect at the beginning of your next billing cycle",
    options: {
      downgrade: {
        description:
          "You'll still have access to weekly actions and text support, but not 1:1 meetings with nurses/coaches or community events.",
        title: "Downgrade to Conceive Plus",
        value: "downgrade",
      },
      upgrade: {
        description:
          "<Emphasis>$t(common.plans.premium): ${{price}} {{interval}}</Emphasis> Adds Crew, Coach, Nurse support and more! <LearnMoreLink>Learn more</LearnMoreLink>",
        title: "Upgrade to Conceive Premium",
        value: "upgrade",
      },
      pause: {
        description:
          "We know this journey is never a straight line. You can take a one-time break during your Conceive journey. We'll be here when you get back!",
        title: "Pause Membership for a Month",
        value: "pause",
      },
      cancel: {
        description: "",
        title: "Cancel membership",
        value: "cancel",
      },
    },
    submitCtaText: "Continue",
    title: "Change Membership Plan",
  },
  pageTitle: "Plan Management",
  viewPlanDetailsCta: "View Plan Details",
};
